import { isProd } from 'helpers/utils';

import { datadogRum } from '@datadog/browser-rum';

const ANALYTICS_CAT_ID = 'C0002';

export const initDatadogRum = () => {
    datadogRum.init({
        applicationId: import.meta.env.DD_APPLICATION_ID,
        clientToken: import.meta.env.DD_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: import.meta.env.PROJECT_NAME,
        env: import.meta.env.ENV,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackingConsent: isProd() ? 'not-granted' : 'granted',
        defaultPrivacyLevel: 'mask-user-input',
    });
    connectDatadogRumOneTrust();
};

export const setDatadogRumUser = (id: number) => {
    datadogRum.setUser({ id: id.toString() });
};

export const trackDatadogRumAction = (name: string, context?: Record<string, unknown>) => {
    datadogRum.addAction(name, context);
};

export const reportDatadogRumError = (error: unknown, context?: Record<string, unknown>) => {
    datadogRum.addError(error instanceof Error ? error : String(error), context);
};

const hasDatadogRumAnalyticsConsent = () => {
    return Boolean(window.OnetrustActiveGroups?.split(',').includes(ANALYTICS_CAT_ID));
};

const applyDatadogRumConsent = () => {
    datadogRum.setTrackingConsent(hasDatadogRumAnalyticsConsent() ? 'granted' : 'not-granted');
};

const connectDatadogRumOneTrust = () => {
    const attachOnConsentChanged = () => {
        if (window.OneTrust?.OnConsentChanged) {
            window.OneTrust.OnConsentChanged(() => applyDatadogRumConsent());
        }
    };

    const prevWrapper = window.OptanonWrapper;

    window.OptanonWrapper = () => {
        applyDatadogRumConsent();
        attachOnConsentChanged();
        prevWrapper?.();
    };
};
